import { cn } from "@/lib/utils"

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        "animate-pulse rounded-sm bg-carbon-100 dark:bg-carbon-800",
        className
      )}
      {...props}
    />
  )
}

export { Skeleton }
